import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { AmstiPloplcClearinghouseBoard } from '@api/BoardSDK';

/**
 * Fetches ALL items from the Clearinghouse board and returns a
 * normalised-name → clockHours map for display-only lookup.
 */
export const getClockHoursMap = createServerFn({ method: 'GET' })
  .validator(z.object({}).optional())
  .handler(async () => {
    const board = new AmstiPloplcClearinghouseBoard();
    const map: Record<string, number | null> = {};
    let cursor: string | undefined;

    // Cursor-loop: the Clearinghouse has a bounded catalogue of PLOs,
    // but we need the full set so every session can be matched.
    do {
      const res = await board
        .items()
        .withColumns(['clockHours'])
        .withPagination({ limit: 500, cursor })
        .execute();

      for (const item of res.items) {
        const key = item.name.trim().toLowerCase();
        map[key] = item.clockHours;
      }

      cursor = res.cursor ?? undefined;
    } while (cursor);

    return { map };
  });
